export default {
  setBannerList(state, data) {
    state.bannerList = data;
  },
};
